import React from 'react';
import { Linkedin, X, Mail, FileText, Instagram } from 'lucide-react';
import { SOCIAL_LINKS } from '../constants';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white pt-20 pb-10 px-6 border-t border-gray-100" id="contact">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="font-serif text-5xl font-bold text-gray-900 mb-8">Let's Connect</h2>
        <p className="text-gray-500 text-lg mb-12 max-w-2xl mx-auto leading-relaxed">
          I write about AI and product strategy. Subscribe to my newsletter or follow me on social media for updates.
        </p>

        <div className="flex justify-center flex-wrap gap-8 mb-20">
          <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center gap-3" aria-label="Jaclyn Konzelmann on LinkedIn">
            <div className="p-5 rounded-full bg-gray-50 text-gray-400 group-hover:bg-[#0077B5] group-hover:text-white transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
              <Linkedin size={28} fill="currentColor" />
            </div>
          </a>
          <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center gap-3" aria-label="Jaclyn Konzelmann on X (formerly Twitter)">
            <div className="p-5 rounded-full bg-gray-50 text-gray-400 group-hover:bg-black group-hover:text-white transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
              <X size={28} strokeWidth={2.5} />
            </div>
          </a>
          <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center gap-3" aria-label="Jaclyn Konzelmann on Instagram">
            <div className="p-5 rounded-full bg-gray-50 text-gray-400 group-hover:bg-gradient-to-tr group-hover:from-[#F58529] group-hover:via-[#DD2A7B] group-hover:to-[#8134AF] group-hover:text-white transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
              <Instagram size={28} />
            </div>
          </a>
          <a href={SOCIAL_LINKS.substack} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center gap-3" aria-label="Thursday Thoughts on AI newsletter">
            <div className="p-5 rounded-full bg-gray-50 text-gray-400 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
              <FileText size={28} />
            </div>
          </a>
        </div>

        <div className="text-center border-t border-gray-100 pt-10">
           <p className="text-xs text-gray-400 font-medium uppercase tracking-[0.2em]">
             © {new Date().getFullYear()} Jaclyn Konzelmann. All rights reserved.
           </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;